import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";
import Seo from "@/components/Seo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="forgot-page">
      <Seo title="Reset your password | Appleman Tech Repair" description="Reset your Appleman Tech Repair account password." />
      <p className="eyebrow text-accent mb-4">Account help</p>
      <h1 className="font-display font-black uppercase tracking-tighter text-4xl mb-8">Forgot your password?</h1>
      {sent ? (
        <div className="border-2 border-black shadow-hard p-8 text-center" data-testid="forgot-sent">
          <MailCheck className="h-12 w-12 mx-auto mb-4 text-accent" />
          <p className="text-neutral-600 leading-relaxed">
            If an account exists for <strong>{email}</strong>, we've emailed a reset link. It works for one hour.
          </p>
          <Link to="/login" className="inline-block mt-6 font-display font-bold uppercase tracking-wider border-b-2 border-black" data-testid="forgot-back-login">
            Back to login
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="border-2 border-black shadow-hard p-8 space-y-5" data-testid="forgot-form">
          <p className="text-sm text-neutral-600">Enter your account email and we'll send you a reset link.</p>
          <div>
            <label className="eyebrow block mb-2" htmlFor="forgot-email">Email</label>
            <input id="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input"
              className="w-full border-2 border-black px-4 py-3 outline-none focus:shadow-hard-sm" placeholder="you@example.com" />
          </div>
          <button type="submit" disabled={busy} data-testid="forgot-submit-btn"
            className="w-full border-2 border-black bg-accent py-4 font-display font-bold uppercase tracking-wider shadow-hard brutal-hover disabled:opacity-50">
            {busy ? "Sending…" : "Email me a reset link"}
          </button>
        </form>
      )}
    </div>
  );
}
